import MainMenu from "./main-menu/MainMenu";
import {Outlet} from "react-router-dom";
import * as React from "react";
import {useMediaQuery, useTheme} from "@mui/material";
import MobileMainMenu from "./main-menu/MobileMainMenu";


export function Content() {

    const theme = useTheme();
    const smAndBiggerScreen: boolean = useMediaQuery(theme.breakpoints.up("sm"));

    let content = smAndBiggerScreen ? <MainMenu /> : <MobileMainMenu />;

    return (
        <>
            {content}
            <Outlet />
        </>
    );

}
